<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <div class="tabs-widget">
        <div class="tab-item active" @click="switchTab('staff')">
          STAFF MEMBERS
        </div>
        <div class="h-spacer"></div>
        <div class="tab-item" @click="switchTab('customer')">
          CUSTOMER MEMBERS
        </div>
      </div>
      <div class="tab-options">
        <b-button type="is-primary" outlined @click="addNew()">CREATE STAFF MEMBER</b-button>
      </div>
    </div>
    <div class="wrapper-body">
      <div v-if="!loading_users && user_data" class="left-panel">
        <div class="user-item" v-for="(item, index) in user_data" :key="index"
          :class="{ active: selected_user && item.id == selected_user.id }" @click="selectUser(item)">
          <widgetProfile :title="`${item.first_name} ${item.last_name}`" :subtitle="item.phone"
            :file_name="item.profile_image" :path="$store.state.ASSETS_BASE_URL + '/assets/uploaded/'"></widgetProfile>

          <b-tag v-if="item.account_type == 'wecodefystaff'" type="is-primary">Wecodefy</b-tag>
          <b-tag v-if="item.account_type == 'streamer'" type="is-info">Partener</b-tag>
          <b-tag v-if="item.account_type == 'gatekeeper'" type="is-warn">Gatekeeper</b-tag>

          <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
            <template #trigger>
              <b-icon icon="dots-vertical"></b-icon>
            </template>
            <b-dropdown-item @click="editItem(item)" v-if="item.account_type != 'gatekeeper'"
              aria-role="listitem">Update</b-dropdown-item>
            <b-dropdown-item @click="deleteItem(item)" aria-role="listitem">Delete</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <div v-if="loading_users" class="left-panel">
        <div class="user-item" v-for="(item, index) in 15" :key="index">
          <b-skeleton width="100%"></b-skeleton>
          <b-skeleton width="40%"></b-skeleton>
        </div>
      </div>
      <div v-if="selected_user" class="rigth-panel">
        <div class="tabs-widget">
          <span class="closeButton" @click="selected_user = null">Close</span>
          <div class="tab-item" :class="{ active: user_selected_tab == 'account_overview' }"
            @click="switchUserTab('account_overview')">
            ACCOUNT OVERVIEW
          </div>
          <div class="h-spacer"></div>
          <div class="tab-item" :class="{ active: user_selected_tab == 'account_permission' }"
            @click="switchUserTab('account_permission')">
            ACCOUNT PERMISSIONS
          </div>
          <div class="h-spacer"></div>
          <!-- <div class="h-spacer" v-if="selected_user.account_type == 'streamer'"></div> -->
          <div class="tab-item" :class="{ active: user_selected_tab == 'domain_registration' }"
            v-if="selected_user.account_type == 'streamer'" @click="switchUserTab('domain_registration')">
            DOMAIN REGISTRATION
          </div>
          <div class="h-spacer" v-if="selected_user.account_type == 'streamer'"></div>
          <div class="tab-item" :class="{ active: user_selected_tab == 'activity_logs' }"
            @click="switchUserTab('activity_logs')">
            ACTIVITY LOGS
          </div>
        </div>

        <userAccountOverview v-if="user_selected_tab == 'account_overview'" :user="selected_user"></userAccountOverview>
        <userAccountPermissions v-if="user_selected_tab == 'account_permission'" @success="getUserData()"
          :user="selected_user">
        </userAccountPermissions>
        <userAccountDomainRegistration v-if="user_selected_tab == 'domain_registration'" :user="selected_user">
        </userAccountDomainRegistration>

      </div>
      <div v-else class="rigth-panel no-data-panel">
        <widgetNotfound title="No User selected" subtitle="Select a user to see  details"></widgetNotfound>
      </div>
    </div>
    <!-- Add new user modal -->
    <addNewStaffUser v-if="show_form" :value="selected_user" @saved="userSaved()" @close="show_form = false">
    </addNewStaffUser>
  </div>
</template>

<script>
import addNewStaffUser from "./modals/addNewStaffUser.vue";
import userAccountOverview from "./components/userAccountOverview.vue";
import userAccountPermissions from "./components/userAccountPermissions.vue";
import userAccountDomainRegistration from "./components/userAccountDomainRegistration.vue";
export default {
  components: {
    addNewStaffUser,
    userAccountOverview,
    userAccountPermissions,
    userAccountDomainRegistration
  },
  data: () => ({
    loading_users: true,
    user_data: null,
    show_form: false,
    selected_user: null,
    loading_save_permissions: false,
    user_selected_tab: "account_overview",
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getUserData();
  },
  methods: {
    selectUser(item) {
      let vm = this;
      vm.selected_user = item;
      vm.user_selected_tab = "account_overview";
    },
    confirmDelete(id) {
      let vm = this;
      vm.$store
        .dispatch("ADMIN_USER_DELETE_ITEM", { id: id })
        .then((response) => {
          vm.getUserData();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
          console.error("ADMIN_USER_DELETE_ITEM", { response });
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    deleteItem(item) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.confirmDelete(item.id);
          }
        },
      });
    },
    editItem(item) {
      let vm = this;
      vm.selected_user = item;
      vm.show_form = true;
    },
    getUserData() {
      let vm = this;
      vm.loading_users = true;
      vm.$store
        .dispatch("ADMIN_USER_GET_USERS")
        .then((response) => {
          vm.loading_users = false;
          vm.user_data = response.data.return.map((item) => {
            vm.$store.state.eventBus.$set(item, "is_menu_open", false);
            return item;
          });
        })
        .catch(({ response }) => {
          vm.loading_users = false;
        });
    },
    addNew() {
      let vm = this;
      vm.selected_user = null;
      vm.show_form = true;
    },
    userSaved() {
      let vm = this;
      vm.show_form = false;
      vm.getUserData();
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    switchUserTab(tab) {
      let vm = this;
      vm.user_selected_tab = tab;
    }
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 55px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;
      white-space: nowrap;
      margin-right: 15px;

      .h-spacer {
        margin-right: 10px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 55px);
    display: flex;
    position: relative;

    .left-panel {
      overflow-y: auto;
      height: 100%;
      width: 400px;
      background: #fff;

      @media (max-width: 800px) {
        width: 40%;
      }

      @media (max-width: 700px) {
        width: 45%;
      }

      @media (max-width: 600px) {
        width: 100%;
      }

      .user-item {
        padding: 10px 10px;
        border-bottom: 1px solid #ddd;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:hover {
          background: #f9f9f9;
        }

        &.active {
          background: #f9f9f9;
        }
      }
    }

    .rigth-panel {
      width: calc(100% - 400px);
      height: 100%;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;
      border-left: 1px solid #e9e9e9;

      @media (max-width: 800px) {
        width: 60%;
      }

      @media (max-width: 700px) {
        width: 55%;
      }

      @media (max-width: 600px) {
        position: absolute;
        background: white;
        top: 0;
        z-index: 999;
        top: 0;
        right: 0px;
        transition: .5s;
        width: 85%;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);

        &.no-data-panel {
          display: none;
        }
      }

      .tabs-widget {
        display: flex;
        align-items: flex-end;
        background-color: #fff;
        border-bottom: 1px solid #ddd;
        height: 55px;
        overflow-x: auto;
        align-items: center;

        span.closeButton {
          cursor: pointer;
          white-space: nowrap;
          margin: 0 10px 0 10px;
          color: red;
          display: none;

          @media (max-width: 600px) {
            display: block;
          }
        }

        .h-spacer {
          margin-right: 10px;
        }

        .tab-item {
          cursor: pointer;
          padding: 14px 4px;
          white-space: nowrap;

          &.active {
            color: var(--wecodefy-secondary-color, #9fc953);
            border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
          }
        }
      }
    }
  }
}
</style>
